export const recommendationVideoTableData = {
    keys: ["name", "s3_key", "voice_text", "created_at", "updated_at"],
    config: {
        name: {
            isVisible: true,
            label: "File Name",
            class: "width-220px",
            searchKey: "asset_survey_project.name",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "user",
            commonSearchKey: "asset_survey_project",
            commonSearchObjectKey: ""
        },
        s3_key: {
            isVisible: true,
            label: "Video",
            class: "width-220px",
            searchKey: "asset_survey_project.s3_key",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "user",
            commonSearchKey: "asset_survey_project",
            commonSearchObjectKey: "s3_key",
            isVideoField: true
        },
        // caption: {
        //     isVisible: true,
        //     label: "Caption",
        //     class: "width-200px",
        //     searchKey: "asset_survey_project.caption",
        //     type: "string",
        //     hasWildCardSearch: true,
        //     hasCommonSearch: false,
        //     getListTable: "user",
        //     commonSearchKey: "asset_survey_project",
        //     commonSearchObjectKey: "caption"
        // },
        voice_text: {
            isVisible: true,
            label: "Narrative",
            class: "width-220px",
            searchKey: "asset_survey_project.voice_text",
            type: "string",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "user",
            commonSearchKey: "asset_survey_project",
            commonSearchObjectKey: "voice_text"
        },

        created_at: {
            isVisible: true,
            label: "Created At",
            class: "width-180px",
            searchKey: "asset_survey_project.created_at",
            type: "date",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "asset_survey_project",
            commonSearchKey: "asset_survey_project",
            commonSearchObjectKey: "created_at"
        },

        updated_at: {
            isVisible: true,
            label: "Updated At",
            class: "width-180px",
            searchKey: "asset_survey_project.updated_at",
            type: "date",
            hasWildCardSearch: true,
            hasCommonSearch: false,
            getListTable: "asset_survey_project",
            commonSearchKey: "asset_survey_project",
            commonSearchObjectKey: "updated_at"
        }
    },
    data: []
};
